import { reactive } from 'vue';

export type ToastType = 'success' | 'error' | 'info';
export interface ToastItem {
  id: number;
  type: ToastType;
  message: string;
}

const state = reactive<{ items: ToastItem[] }>({ items: [] });
let seq = 0;

function push(type: ToastType, message: string, ttl: number): void {
  const id = ++seq;
  state.items.push({ id, type, message });
  window.setTimeout(() => dismiss(id), ttl);
}

export function dismiss(id: number): void {
  const i = state.items.findIndex((t) => t.id === id);
  if (i >= 0) state.items.splice(i, 1);
}

export function useToastState() {
  return state;
}

/**
 * Глобальные тосты: `toast.success('…')`, `toast.error('…')`.
 *
 * `ttl` — для длинных сообщений вроде отчёта о пакетной печати: список из
 * пяти фамилий за шесть секунд не прочитать.
 */
export const toast = {
  success: (message: string, ttl = 4000): void => push('success', message, ttl),
  error: (message: string, ttl = 6000): void => push('error', message, ttl),
  info: (message: string, ttl = 4000): void => push('info', message, ttl),
};
